module.exports = __webpack_public_path__ + "img/aw.37fff4c3.png";